import React, { Component, ReactNode } from "react";
import { FormFeedback, Input, Progress } from "reactstrap";
import arquivos from "../../api/arquivos";

interface AtividadesUploadInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  onUriChanged: (uri: string) => void;
  format?: string;
}

interface AtividadesUploadInputState {
  progress: number;
  error: string | null;
}

export class AtividadesUploadInput extends Component<
  AtividadesUploadInputProps,
  AtividadesUploadInputState
> {
  constructor(props: AtividadesUploadInputProps) {
    super(props);
    this.state = {
      progress: -1,
      error: null,
    };
  }

  getFormat() {
    return this.props.format ?? "pdf";
  }

  onInputChanged(files: FileList | null) {
    if (!files || files.length == 0) return;

    this.setState({ progress: 0, error: null });

    arquivos
      .create(this.getFormat())
      .then(
        (res) =>
          new Promise<string>((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.upload.addEventListener("progress", (event) => {
              this.setState({
                progress: Math.round((100 * event.loaded) / event.total),
              });
            });

            xhr.addEventListener("load", () => {
              if (xhr.status == 200) {
                resolve(res);
              } else {
                reject(new Error(xhr.statusText));
              }
            });

            xhr.addEventListener("error", () =>
              reject(new Error("Erro ao enviar o arquivo."))
            );

            xhr.addEventListener("abort", () =>
              reject(new Error("Envio cancelado."))
            );

            xhr.open("PUT", res);

            xhr.setRequestHeader("x-amz-acl", "public-read");

            xhr.send(files[0]);
          })
      )
      .then((res) => {
        const i = res.indexOf("?");
        this.setState({ progress: -1, error: null });
        this.props.onUriChanged(i > 0 ? res.substring(0, i) : res);
      })
      .catch((err) => {
        this.setState({
          progress: -1,
          error: err instanceof Error ? err.message : "Erro desconhecido",
        });
      });
  }

  render(): ReactNode {
    const props = { ...this.props } as Partial<AtividadesUploadInputProps>;
    delete props.onUriChanged;

    return (
      <div>
        <Input
          {...props}
          type="file"
          accept={`.${this.getFormat()}`}
          onChange={(e) => this.onInputChanged(e.target.files)}
          invalid={!!this.state.error}
        />
        <FormFeedback>{this.state.error}</FormFeedback>
        {this.state.progress >= 0 && (
          <Progress
            value={this.state.progress}
            animated
            style={{ height: "4px", marginTop: "5px" }}
          />
        )}
      </div>
    );
  }
}
